import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@app/shared/services/api/api.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Buildings } from '../models/buildings';
import { ViewBuildingAlarmsExtendedInfo1Dto, ViewBuildingAlarmsExtendedInfo1DtoWithCountTrue } from '../models/ViewBuildingAlarmsExtendedInfo1';

@Injectable({
  providedIn: 'root',
})
export class BuildingsService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  dbColumnNames = [
    'Guid',
    'BuildingTypeId',
    'ConnectionObjectNumber',
    'MunicipalityId',
    'MunicipalityKey',
    'Municipality',
    'DistrictNumber',
    'District',
    'Street',
    'HouseNumber',
    'HouseNumberAdditive',
    'LocationInfo',
    'ZipCode',
    'RegionName',
    'Latitude',
    'Longitude',
    'Name',
    'Description',
    'Number',
    'FloorArea',
    'EnergyCategory',
    'IsEnergyGuardNotificationActive',
    'EnergyGuardNotificationUserId',
    'CreationDate',
    'ModifyDate',
    'ModifyUser',
    'gpsModifiedBy',
    'gpsModifyDate',
    'PKID',
    'Guid',
    'ItemId',
    'MunicipalityKey',
    'MunicipalityNumber',
    'MunicipalityTypeId',
    'RegionalKey',
    'Name',
    'AdministrationCollectivityId',
    'AdministrationCollectivity',
    'CustomerCenterId',
    'CustomerCenter',
    'PrimaryAdminGuid',
    'MailSendWorkOrderTo',
    'ZipCode',
    'ColorCode01',
    'ColorCode02',
    'ColorCode03',
    'LastDataImportDate',
    'LastLightPerformanceCalculationDate',
    'SumWattCurrent',
    'SumLumenCurrent',
    'SumWattOptimized',
    'SumLumenOptimized',
    'GrossElectricityPricePerUnit',
    'Co2Emission',
    'Image',
    'ImageName',
    'IsGeneralReportingDamageEnabled',
    'IsInTestMode',
    'IsActive',
    'IsDeactivated',
    'IsDeleted',
    'CreationDate',
    'ModifyDate',
    'ModifyUser',
    'EnergyMonitorUrl',
    'ClimateNaviUrl',
    'LocalElectricityMarketUrl',
    'IsProposedMeterReadingEnabled',
    'DmgRepPWAActive',
    'PKID',
  ];

  getById(guid: string, municipalityKey: string): Observable<Buildings> {
    return this.http
      .get<Buildings[]>(this.endpoint(`socrates/meters/api/municipalities/${municipalityKey}/buildings/${guid}?$expand=buildingType`))
      .pipe(map((buildings: Buildings[]): Buildings => buildings[0] || ({} as Buildings)));
  }

  updateBuildingNotification(guid: string, isEnergyGuardNotificationActive: boolean, municipalityKey: string) {
    const body = {
      isEnergyGuardNotificationActive: isEnergyGuardNotificationActive,
    };
    return this.http.patch(this.endpoint(`socrates/meters/api/municipalities/${municipalityKey}/buildings/${guid}`), body);
  }

  public getLicensedMetersByConnectionObjectNumber(connectionObjectNumber: string): Observable<ViewBuildingAlarmsExtendedInfo1Dto[]> {
    let url = `socrates/meters/api/views/ViewBuildingAlarmsExtendedInfo1?$count=true`;
    url += `&$filter=connectionObjectNumber eq '${connectionObjectNumber}'`;
    url += ` and isEnergyGuardLicenseAvailable eq true`;
    return this.http
      .get<ViewBuildingAlarmsExtendedInfo1DtoWithCountTrue>(this.endpoint(encodeURI(url)))
      .pipe(map((response: ViewBuildingAlarmsExtendedInfo1DtoWithCountTrue): ViewBuildingAlarmsExtendedInfo1Dto[] => response.data));
  }
}
